import { FC } from 'react';
import type { SeopBands } from '@/types/seop';
import PercentInput from './PercentInput';

interface BandsEditorProps {
  bands: SeopBands;
  disabled: boolean;
  onCommit: (mudanca: Partial<SeopBands>) => void;
}

const CAMPOS: { campo: keyof SeopBands; label: string; titulo: string }[] = [
  { campo: 'balanceado_min', label: 'Balanceado a partir de', titulo: 'Abaixo disto o recurso aparece como Folga' },
  { campo: 'atencao_min', label: 'Atenção acima de', titulo: 'Teto do Balanceado' },
  { campo: 'critico_min', label: 'Crítico acima de', titulo: 'Acima disto o recurso aparece como Crítico' },
];

/**
 * As três fronteiras do semáforo, editáveis na própria tela em que elas pintam.
 *
 * No app de origem esses cortes são literais no código, e o teto do "Balanceado" era
 * 105% — uma tolerância que a operação não quer mais enxergar como equilíbrio. Aqui o
 * número é cadastro: quem planeja muda sem depender de deploy.
 *
 * Cada campo confirma sozinho, no blur. A ordem (balanceado ≤ atenção ≤ crítico) é
 * validada no servidor de propósito: é lá que ela precisa valer, e travar no cliente
 * impediria o caminho natural de subir o teto antes de subir o piso.
 */
const BandsEditor: FC<BandsEditorProps> = ({ bands, disabled, onCommit }) => (
  <div className="flex flex-wrap items-center gap-3" data-testid="seop-bands-editor">
    {CAMPOS.map(({ campo, label, titulo }) => (
      <label key={campo} className="flex items-center gap-1.5 text-xs text-content-muted" title={titulo}>
        {label}
        <PercentInput
          value={Math.round(bands[campo] * 1000) / 10}
          disabled={disabled}
          label={label}
          step={1}
          max={1000}
          className="w-16 rounded border border-theme-border bg-surface-secondary px-2 py-1 text-right text-sm text-content-primary"
          onCommit={(texto) => {
            const numero = Number(texto);
            if (!Number.isFinite(numero)) return;
            const fracao = Math.round(numero * 10) / 1000;
            if (fracao !== bands[campo]) onCommit({ [campo]: fracao });
          }}
        />
        %
      </label>
    ))}
  </div>
);

export default BandsEditor;
